import React from "react";

import { useRoutes } from "react-router-dom";
import GamePage from "../pages/GamePage";
import BuyTicketPage from "../pages/BuyTicketPage";
import HistoryPage from "../pages/HistoryPage";
import { Navigate } from "react-router-dom";
import GameV2Page from "../pages/GameV2Page";
import GameV2Select from "../pages/GameV2Select";
import UnauthenticatedPage from "../pages/UnauthenticatedPage";
import ProtectedRoute from "../components/ProtectedRoute";

function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Navigate to="/game2" replace />,
    },
    // {
    //   path: "/game",
    //   element: (
    //     <ProtectedRoute>
    //       <GamePage />
    //     </ProtectedRoute>
    //   ),
    // },
    {
      path: "/game2",
      element: (
        <ProtectedRoute>
          <GameV2Page />
        </ProtectedRoute>
      ),
    },
    {
      path: "/game2/select/:ticketId",
      element: <GameV2Select />,
    },
    {
      path: "/buy-ticket",
      element: (
        <ProtectedRoute>
          <BuyTicketPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/unauthenticated",
      element: <UnauthenticatedPage />,
    },
    {
      path: "/history",
      element: <HistoryPage />,
    },
    {
      path: "*",
      element: <Navigate to="/game" replace />,
    },
  ]);
}

export default Router;
